<template>
  <div class="work">
    <h2>
      工作原理&nbsp;<img
        :src="isSet ? afterSet : beforeSet"
        class="set"
      />
    </h2>
    <div class="wrapper">
      <div v-if="!isSet" class="svg">
        <svg
          v-if="!isSet"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-100 -50 1200 455"
          version="1.1"
          :style="{
            opacity: finish ? '0.3' : '1'
          }"
        >
          <g fill="none" :stroke="strokeColor" stroke-width="1">
            <path
              :stroke-dasharray="strokeDasharray"
              d="M0 0 l1000 0 V 350 H0 Z M0 200 H100 V150 H1000 M100 200 V250 H200 V350 M200 250 H400 M400 150 V350 M325 0 V150 M600 0 V250 H650 V350 M600 250 H550 V350 M800 150 V250 H1000"
            />
            <!-- 变红的线 -->
            <path d="M0 0 l325 0" id="theMotionPath" stroke="transparent" />
            <path
              d="M325 0 V150 H625"
              id="theMotionPath2"
              stroke="transparent"
            />
            <path
              d="M625 150 H800 V250 H925"
              id="theMotionPath3"
              stroke="transparent"
            />
            <!-- 变红的电脑 -->
            <Computer x="300" y="-25" :color="first" />
            <Computer x="575" y="125" :color="second" />
            <Computer x="775" y="-25" />
            <Computer x="175" y="325" />
            <Computer x="525" y="325" />
            <!-- 防火墙 -->
            <image
              x="-50"
              y="-50"
              width="100"
              height="100"
              :xlink:href="brokeFire ? fire2 : fire"
            />
            <!-- hacker -->
            <image
              x="-100"
              y="-50"
              width="100"
              height="100"
              xlink:href="../assets/animate/hacker.png"
            />
            <!-- 主机 -->
            <image
              x="922"
              y="150"
              width="149"
              height="150"
              :xlink:href="broke ? host2 : host"
            />
          </g>
        </svg>
        <img :src="over" v-if="finish" class="over" />
      </div>

      <div v-else class="svg">
        <svg
          v-if="isSet"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-100 -50 1200 455"
          version="1.1"
          :style="{
            opacity: finish ? '.3' : '1'
          }"
        >
          <g fill="none" :stroke="strokeColor" stroke-width="1">
            <path
              :stroke-dasharray="strokeDasharray"
              d="M0 0 l1000 0 V 350 H0 Z M0 200 H100 V150 H1000 M100 200 V250 H200 V350 M200 250 H400 M400 150 V350 M325 0 V150 M600 0 V250 H650 V350 M600 250 H550 V350 M800 150 V250 H1000 M175 0 V150"
            />
            <!-- 变红的线 -->
            <path d="M0 0 l150 0" id="theAfterPath" stroke="transparent" />
            <path d="M0 0 V200 H125" id="theAfterPath2" stroke="transparent" />
            <path d="M0 0 V350" id="theAfterPath3" stroke="transparent" />
            <!-- 变红的电脑 -->
            <Computer x="375" y="-25" />
            <Computer x="775" y="-25" />
            <Computer x="575" y="125" />
            <Computer x="175" y="325" />
            <Computer x="525" y="325" />

            <!-- 蜜罐 -->
            <Computer x="150" y="-25" :color="oringe" />
            <Computer x="575" y="-25" :color="oringe" />
            <Computer x="975" y="-25" :color="oringe" />

            <Computer x="155" y="125" :color="oringe" />
            <Computer x="375" y="125" :color="oringe" />
            <Computer x="775" y="125" :color="oringe" />

            <Computer x="75" y="175" :color="oringe" />

            <Computer x="525" y="225" :color="oringe" />
            <Computer x="275" y="225" :color="oringe" />
            <Computer x="775" y="225" :color="oringe" />
            
            <Computer x="-25" y="325" :color="oringe" />
            <Computer x="375" y="325" :color="oringe" />
            <Computer x="775" y="325" :color="oringe" />

            <!-- 告警 -->
            <image
              x="200"
              y="-30"
              width="25"
              height="25"
              v-if="warn1"
              :xlink:href="warning"
            />
            <image
              x="130"
              y="185"
              width="25"
              height="25"
              v-if="warn2"
              :xlink:href="warning"
            />
            <image
              x="25"
              y="320"
              width="25"
              height="25"
              v-if="warn3"
              :xlink:href="warning"
            />

            <!-- 防火墙 -->
            <image
              x="-50"
              y="-50"
              width="100"
              height="100"
              :xlink:href="brokeFire ? fire2 : fire"
            />
            <!-- hacker -->
            <image
              x="-100"
              y="-50"
              width="100"
              height="100"
              xlink:href="../assets/animate/hacker.png"
            />
            <!-- 主机 -->
            <image
              x="922"
              y="150"
              width="149"
              height="150"
              :xlink:href="host"
            />
          </g>
        </svg>
        <img :src="win" v-if="finish" class="win" />
      </div>
    </div>
  </div>
</template>
<script>
const BLUE = "blue";
const RED = "red";
const ORINGE = "oringe";
import Computer from "../components/Computer.vue";
import host from "../assets/animate/host.png";
import host2 from "../assets/animate/host2.png";
import fire from "../assets/animate/fire.png";
import fire2 from "../assets/animate/fire2.png";
import over from "../assets/animate/over.png";
import win from "../assets/animate/win.png";
import beforeSet from "../assets/animate/beforeSet.png";
import afterSet from "../assets/animate/afterSet.png";
import warning from "../assets/animate/warning.png";

export default {
  components: {
    Computer
  },
  data() {
    return {
      blue: BLUE,
      red: RED,
      oringe: ORINGE,
      host,
      host2,
      fire,
      fire2,
      over,
      win,
      beforeSet,
      afterSet,
      warning,
      strokeColor: "#7fbdff",
      strokeDasharray: "4 4",
      computerWidth: "50",
      // flag: true,
      first: BLUE,
      second: BLUE,
      // 部署前后
      isSet: true,
      // 防火墙
      brokeFire: false,
      // 主机被破坏
      broke: false,
      // 告警
      warn1: false,
      warn3: false,
      warn2: false,

      // 成功后
      finish: false
    };
  },
  mounted() {
    this.begin();
  },
  methods: {
    begin() {
       // reset
      this.finish = false;
      this.clearLine()
      this.isSet = !this.isSet
      if (this.isSet) {
        this.after();
      } else {
        this.before();
      }
    },
    before() {
      this.brokeFire = true;
      // 清除
      this.first = BLUE;
      this.second = BLUE;
      this.broke = false;
      this.drawLine("theMotionPath", () => {
        this.first = RED;
        this.drawLine("theMotionPath2", () => {
          this.second = RED;
          this.drawLine("theMotionPath3", () => {
            this.broke = true;
            this.finished()
          });
        });
      });
    },
    after() {
      this.brokeFire = false;
      // 清除
      this.warn1 = false;
      this.warn2 = false;
      this.warn3 = false;
      this.drawLine("theAfterPath", () => {
        this.warn1 = true;
        this.drawLine("theAfterPath2", () => {
          this.warn2 = true;
          this.drawLine("theAfterPath3", () => {
            this.warn3 = true;
            this.finished()
          });
        });
      });
    },
    finished() {
      setTimeout(() => {
        this.finish = true;
        setTimeout(() => {
          this.begin()
        }, 1000);
      }, 500);
    },
    clearLine() {
      const lines = ["theAfterPath", "theAfterPath2", "theAfterPath3", "theMotionPath", "theMotionPath2", "theMotionPath3"];
      lines.map(item => {
        let ele = document.getElementById(item)
        if (ele)
        ele.style.stroke = "transparent"
      })
    },
    drawLine(id, cb) {
      setTimeout(() => {
        let path = document.getElementById(id);
        if (!path) {
          // console.log("未发现元素", id);
          return;
        }
        let len = path.getTotalLength(); // 325
        let oriLen = len;
        let timer = setInterval(() => {
          path.style.strokeDasharray = len + " " + len;
          path.style.stroke = RED;
          // speed
          oriLen = oriLen - 1.5;
          path.style.strokeDashoffset = oriLen + "";
          if (oriLen < 0) {
            clearInterval(timer);
            if (cb) cb();
          }
        }, 5);
      }, 500);
    }
  }
};
</script>
<style>
/* path{
  stroke: transparent;
} */
.work {
  /* height: 600px; */
}
.set {
  height: 26px;
  width: 58px;
  vertical-align: middle;
}
.wrapper .svg{
  text-align: center;
  min-height: 300px;
}
svg{
  width: 1100px;
  height: 400px;
  margin: 50px;
}

.lineturnRed {
  --initialStroke: 0;
  --transitionDuration: 0;
  stroke-opacity: 1;
  stroke-dasharray: var(--initialStroke);
  stroke-dashoffset: var(--initialStroke);
  transition: stroke-dashoffset 2s ease-in-out;
}

.over,
.win {
  max-width: 300px;
  max-height: 300px;
  position: absolute;
  left: 50%;
  margin-left: -150px;
  top: 50%;
  margin-top: -150px;
}
</style>
